import { MantineThemeOverride } from '@mantine/core';

export type OverlayTheme = NonNullable<MantineThemeOverride['components']>['Overlay'];

export const Overlay: OverlayTheme = {
  // todo: define
};
